import React, { useEffect, useRef, useState } from "react";

import Box from "./Box";
import Button from "./Button";
import ChevronIcon from "../assets/chevron.svg";
import RadioButton from "./RadioButton";
import SmallCaps from "./SmallCaps";
import { useListingsContext } from "./ListingsContext";
import { SORT_OPTIONS } from "../core/constants";

function SortBy() {
  const ref = useRef();
  const [active, setActive] = useState(false);
  const { currentSortKey, handleSort } = useListingsContext();

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const handleClick = (e) => {
    if (!ref.current.contains(e.target)) {
      setActive(false);
    }
  };

  const currentSortOption = SORT_OPTIONS.find((option) => {
    return option.key == currentSortKey;
  });

  return (
    <Box ref={ref} position="relative">
      <Button
        onClick={() => setActive(!active)}
        display="flex"
        alignItems="center"
      >
        <Box pr={15}>
          <SmallCaps>
            Sort: {currentSortKey && currentSortOption.label}
          </SmallCaps>
        </Box>
        <Box
          transform={active ? "rotate(90deg)" : "rotate(270deg)"}
          display="flex"
          alignItems="center"
        >
          <ChevronIcon aria-label="Arrow" />
        </Box>
      </Button>
      <Box
        position="absolute"
        top="calc(100% + 12px)"
        right={0}
        bg="white"
        px={20}
        py={20}
        width={220}
        opacity={active ? 1 : 0}
        pointerEvents={active ? "all" : "none"}
        transition="opacity 200ms"
        border="1px solid black"
      >
        {currentSortKey &&
          SORT_OPTIONS.map((option) => {
            const activeOption = option === currentSortOption;
            return (
              <Box key={option.label} py="5px">
                <RadioButton
                  label={option.label}
                  active={activeOption}
                  onClick={() => {
                    if (!activeOption) {
                      setActive(false);
                      handleSort(option.key);
                    }
                  }}
                />
              </Box>
            );
          })}
      </Box>
    </Box>
  );
}
export default SortBy;
